import { interceptorMiddleware } from '../../../../app/shared/services/interceptor.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import { apiUrl } from '../utils/apiUrl.dashboard';
import {
    AnalyticsData,
    AverageRating,
    EventPreferences,
    TopSearches,
} from '../utils/types.dashboard';

// Define a service using a base URL and expected endpoints
export const businessDashboardApi = createApi({
    reducerPath: 'businessDashboard',
    baseQuery: interceptorMiddleware,
    tagTypes: ['businessDashboard'],
    endpoints: (builder) => ({
        getAnalytics: builder.query<
            { data: AnalyticsData },
            { id?: number | string }
        >({
            query: ({ id }) => ({
                url: id
                    ? `${apiUrl.GET_ANALYTICS}?user_id=${id}`
                    : apiUrl.GET_ANALYTICS,
                method: 'GET',
            }),
            providesTags: ['businessDashboard'],
        }),
        getEventPreferences: builder.query<
            EventPreferences,
            { id?: number | string }
        >({
            query: ({ id }) => ({
                url: id
                    ? `${apiUrl.GET_TOP_PREFERENCES}?user_id=${id}`
                    : apiUrl.GET_TOP_PREFERENCES,
                method: 'GET',
            }),
            providesTags: ['businessDashboard'],
        }),
        getTopSearches: builder.query<TopSearches, { id?: number | string }>({
            query: ({ id }) => ({
                url: id
                    ? `${apiUrl.GET_TOP_SEARCH}?user_id=${id}`
                    : apiUrl.GET_TOP_SEARCH,
                method: 'GET',
            }),
            providesTags: ['businessDashboard'],
        }),
        getAvgRating: builder.query<
            { data: AverageRating },
            { id?: number | string }
        >({
            query: ({ id }) => ({
                url: id
                    ? `${apiUrl.GET_AVERAGE_RATING}?user_id=${id}`
                    : apiUrl.GET_AVERAGE_RATING,
                method: 'GET',
            }),
            providesTags: ['businessDashboard'],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAnalyticsQuery,
    useGetEventPreferencesQuery,
    useGetTopSearchesQuery,
    useGetAvgRatingQuery,
} = businessDashboardApi;
